import {
  ClientAgingInitialValues,
  ClientAgingOptions,
  getClientAgingGroupByOptions,
} from "components/MultiSaleReports/SingleReportForm/ClientAgingFields";

import { OutputFormat } from "constants/reports";

import { loadSavedFormValues, saveFormValues } from "lib/savedFormValues";

const STORAGE_KEY = "clientAgingReportFormValues";

const SAVED_FIELDS = [...Object.keys(ClientAgingInitialValues), "outputFormat"];

const BOOLEAN_FIELDS = ["showContactDetails"];

type ClientAgingSavedValues = typeof ClientAgingInitialValues & {
  outputFormat: string;
};

const isOption = (
  options: { value: unknown }[] | undefined,
  value: unknown,
): boolean => Boolean(options?.some(option => option.value === value));

export const loadClientAgingValues = (
  outputFormatOptions: string[],
  isLivestockAgent: boolean,
): ClientAgingSavedValues => {
  const values = loadSavedFormValues<ClientAgingSavedValues>(
    STORAGE_KEY,
    { ...ClientAgingInitialValues, outputFormat: outputFormatOptions[0] },
    (field, value) => {
      if (field === "outputFormat") {
        return outputFormatOptions.includes(value as string);
      }
      if (field === "groupBy") {
        return isOption(getClientAgingGroupByOptions(isLivestockAgent), value);
      }
      if (BOOLEAN_FIELDS.includes(field)) {
        return typeof value === "boolean";
      }
      return isOption(
        ClientAgingOptions[field as keyof typeof ClientAgingOptions],
        value,
      );
    },
  );
  // Group By only applies to PDFs, where its field is enabled.
  if (values.outputFormat !== OutputFormat.PDF) {
    values.groupBy = ClientAgingInitialValues.groupBy;
  }
  return values;
};

export const saveClientAgingValues = (values: Record<string, unknown>): void =>
  saveFormValues(STORAGE_KEY, values, SAVED_FIELDS);
